<script>
import Layout from '../../layouts/main'
import appConfig from "@/app.config";

export default {
   page: {
    title: "Order",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: 'Order',
      items: [
        {text: 'Ecommerce',href: '/',},
        {text: 'Order',active: true,},
      ],
      booking_id:"",
    userData: JSON.parse(localStorage.getItem("user")),
    }
  },
  mounted() {
    this.booking_id = this.$route.query.booking_id;
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-center p-5">
              <div class="text-center">
                <i class="mdi mdi-check-circle mdi-48px"></i><br>
                <h4>Hi, {{ userData.first_name }} {{ userData.last_name }} </h4>
                <span>Your Booking has been placed successfully</span><br>
                <h6>Booking ID: <span class="text-danger h3">#{{booking_id}}</span> </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mx-auto d-flex justify-content-between">
                <router-link to="/products" class="btn btn-success"><i class="mdi mdi-arrow-left me-1"></i> Back to Booking </router-link>
                <router-link to="/dashboard" class="btn btn-primary">Continue to Account <i class="mdi mdi-arrow-right ms-1"></i> </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
